var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg333Mbf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    enableBackground: "new 0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.565,
    y: 107.062,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -74.4511 74.3862)",
    width: 40,
    height: 40
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72.164,
    y: 67.464,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -34.8528 90.788)",
    width: 39.999,
    height: 40.001
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 111.761,
    y: 27.866,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 4.746 107.1909)",
    width: 39.999,
    height: 40.001
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 72.305,
    y: 146.519,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -90.7112 114.0419)",
    width: 40.001,
    height: 40.001
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 111.903,
    y: 106.922,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -51.1134 130.441)",
    width: 40.001,
    height: 39.999
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 151.501,
    y: 67.323,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -11.5154 146.8459)",
    width: 40,
    height: 40
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 111.974,
    y: 186.046,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -107.0435 153.6732)",
    width: 39.999,
    height: 40.001
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 151.572,
    y: 146.448,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -67.4445 170.067)",
    width: 39.999,
    height: 40.001
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 191.17,
    y: 106.85,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -27.8474 186.4691)",
    width: 40.001,
    height: 40.001
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 32.458,
    y: 341.045,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -239.9365 142.8461)",
    width: 40.001,
    height: 40.001
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 72.056,
    y: 301.447,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -200.3379 159.248)",
    width: 39.999,
    height: 40.001
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 111.654,
    y: 261.849,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -160.7393 175.6498)",
    width: 39.999,
    height: 40.001
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 72.197,
    y: 380.502,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -256.1935 182.498)",
    width: 40.001,
    height: 40.001
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 111.796,
    y: 340.905,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -216.5901 198.8882)",
    width: 40,
    height: 39.998
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 151.394,
    y: 301.307,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -176.9962 215.2961)",
    width: 39.999,
    height: 39.999
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 111.867,
    y: 420.029,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -272.525 222.1251)",
    width: 39.998,
    height: 40
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 151.465,
    y: 380.43,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -232.9237 238.5201)",
    width: 39.999,
    height: 40.001
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 191.062,
    y: 340.833,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -193.3268 254.9223)",
    width: 40.001,
    height: 40.001
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M443.368,249.918c4.93-76.658,73.936-190.163-58.732-190.163c-111.139,0-118.596,96.192-118.596,190.163 c0,84.969,4.043,186.586,106.525,190.163C515.438,445.067,448.847,335.106,443.368,249.918z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg333Mbf);
export default __webpack_public_path__ + "static/media/333mbf.2e6d7963b9617ab828e6a79868d0a8d9.svg";
export { ForwardRef as ReactComponent };